import {AppNotificationType} from "../../domain/model/app_notification_message";

interface IAddAppNotificationRequest {
    type: AppNotificationType,
    message: string,
}
class AddAppNotificationRequest implements IAddAppNotificationRequest {
    public type: AppNotificationType;
    public message: string;
}

interface IHiddenAppNotificationRequest {
    id: string,
}
class HiddenAppNotificationRequest implements IHiddenAppNotificationRequest {
    public id: string;
}

export {
    AddAppNotificationRequest,
    HiddenAppNotificationRequest,
}



// WEBPACK FOOTER //
// ./src/presentation/request/app_notification_message_request.ts